<template>
  <div id="app">
    <MobileMenu />
    <Menu />
    <main class="content">
      <router-view />
    </main>
    <Footer />
  </div>
  
</template>

<script>
import Menu from './components/navigation/Menu.vue'
import Footer from './components/navigation/Footer.vue'
import MobileMenu from './components/navigation/MobileMenu.vue'

export default {
  name: 'App',
  components: { Menu, Footer, MobileMenu }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.content {
  flex: 1 0 auto;
}

</style>
